export interface CategoriasComponentesHistorico {
    id: number, 
    nome: string, 
    grupo: string, 
    considerar_peso_telhado: boolean, 
    ordem_listagem: number, 
    created_at?: any, 
    updated_at?: any, 
    deleted_at?: any, 
}

export const DEFAULT_CATEGORIAS_COMPONENTES: CategoriasComponentesHistorico[] = [
    {
      id: 30,
      nome: "Microinversor",
      grupo: "inversores",
      considerar_peso_telhado: true,
      ordem_listagem: 3,
    },
    {
      id: 2,
      nome: "Inversores",
      grupo: "inversores",
      considerar_peso_telhado: false,
      ordem_listagem: 2
    },
    {
      id: 21,
      nome: "Emenda para Perfil de Alumínio",
      grupo: "itens_estrutura",
      considerar_peso_telhado: true,
      ordem_listagem: 9
    },
    {
      id: 10,
      nome: "Itens para Estrutura",
      grupo: "itens_estrutura",
      considerar_peso_telhado: true,
      ordem_listagem: 99
    },
    {
      id: 34,
      nome: "Grampo de Fixação p/ Microinversor",
      grupo: "acessorios",
      considerar_peso_telhado: true,
      ordem_listagem: 15
    },
    {
      id: 35,
      nome: "Mão Francesa",
      grupo: "itens_estrutura",
      considerar_peso_telhado: true,
      ordem_listagem: 14
    },
    {
      id: 33,
      nome: "Roteador",
      grupo: "acessorios",
      considerar_peso_telhado: true,
      ordem_listagem: 22
    },
    {
      id: 11,
      nome: "Acessórios",
      grupo: "acessorios",
      considerar_peso_telhado: true,
      ordem_listagem: 98
    },
    {
      id: 24,
      nome: "Conector",
      grupo: "acessorios",
      considerar_peso_telhado: true,
      ordem_listagem: 20
    },
    {
      id: 4,
      nome: "Stringbox",
      grupo: "acessorios",
      considerar_peso_telhado: false,
      ordem_listagem: 19
    },
    {
      id: 23,
      nome: "Cabo",
      grupo: "acessorios",
      considerar_peso_telhado: false,
      ordem_listagem: 18
    },
    {
      id: 31,
      nome: "Conector AC Fêmea p/ Microinversor",
      grupo: "acessorios",
      considerar_peso_telhado: true,
      ordem_listagem: 16
    },
    {
      id: 32,
      nome: "Terminal Final Fêmea p/ Microinversor",
      grupo: "acessorios",
      considerar_peso_telhado: true,
      ordem_listagem: 17
    },
    {
      id: 200,
      nome: "Verticais (Produto 198)",
      grupo: "verticais",
      considerar_peso_telhado: false,
      ordem_listagem: 97
    },
    {
      id: 110,
      nome: "Baterias",
      grupo: "baterias",
      considerar_peso_telhado: false,
      ordem_listagem: 21
    },
    {
      id: 100,
      nome: "Controladores de Carga",
      grupo: "controladores",
      considerar_peso_telhado: false,
      ordem_listagem: 4
    },
    {
      id: 120,
      nome: "Iluminação Solar",
      grupo: "iluminacao",
      considerar_peso_telhado: false,
      ordem_listagem: 21
    },
    {
      id: 130,
      nome: "Onda Senoidal",
      grupo: "inversores",
      considerar_peso_telhado: true,
      ordem_listagem: 4
    },
    {
      id: 140,
      nome: "Onda Modificada",
      grupo: "inversores",
      considerar_peso_telhado: true,
      ordem_listagem: 5
    },
    {
      id: 150,
      nome: "Drive Solar",
      grupo: "inversores",
      considerar_peso_telhado: true,
      ordem_listagem: 6
    },
    {
      id: 160,
      nome: "Carregador",
      grupo: "inversores",
      considerar_peso_telhado: true,
      ordem_listagem: 7
    },
    {
      id: 1,
      nome: "Módulo",
      grupo: "modulos",
      considerar_peso_telhado: true,
      ordem_listagem: 1
    },
    {
      id: 27,
      nome: "Chapa Metálica",
      grupo: "itens_estrutura",
      considerar_peso_telhado: true,
      ordem_listagem: 11
    },
    {
      id: 28,
      nome: "Grampo Final",
      grupo: "itens_estrutura",
      considerar_peso_telhado: true,
      ordem_listagem: 12
    },
    {
      id: 22,
      nome: "Grampo Intermediário",
      grupo: "itens_estrutura",
      considerar_peso_telhado: true,
      ordem_listagem: 10
    },
    {
      id: 20,
      nome: "Kit de Estrutura de Fixação",
      grupo: "itens_estrutura",
      considerar_peso_telhado: true,
      ordem_listagem: 5
    },
    {
      id: 25,
      nome: "Kit de Junção",
      grupo: "itens_estrutura",
      considerar_peso_telhado: true,
      ordem_listagem: 8
    },
    {
      id: 19,
      nome: "Perfil de Alumínio",
      grupo: "itens_estrutura",
      considerar_peso_telhado: true,
      ordem_listagem: 6
    },
    {
      id: 26,
      nome: "Suporte",
      grupo: "itens_estrutura",
      considerar_peso_telhado: true,
      ordem_listagem: 13
    },
    {
      id: 29,
      nome: "Suporte de Solo",
      grupo: "itens_estrutura",
      considerar_peso_telhado: false,
      ordem_listagem: 7
    },
  ]